import { gql } from '@apollo/client';

export const FETCH_SCRAPER_DETAILS_VALIDITY = gql`
  query Flex_ScraperDetailsValidity($utilityAccountId: Int!) {
    utilityAccount(id: $utilityAccountId) {
      hasInValidScraperDetails
    }
  }
`;
